import { render, staticRenderFns } from "./ActivityUpdateModal.vue?vue&type=template&id=b6b781d4&scoped=true"
import script from "./ActivityUpdateModal.vue?vue&type=script&lang=ts"
export * from "./ActivityUpdateModal.vue?vue&type=script&lang=ts"
import style0 from "./ActivityUpdateModal.vue?vue&type=style&index=0&id=b6b781d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b781d4",
  null
  
)

export default component.exports